// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3T8Cg","log":"ModalInventoryLogs_log__39oMk","date":"ModalInventoryLogs_date__3dmUN","userName":"ModalInventoryLogs_userName__3es_s"};